import Notification from "./Notifications.component.jsx";

export default Notification;